import Vue from 'vue';
import PageRecipients from '@/plugins/graphql/queries/v2/survey-recipients-by-segment.gql';
import { omitBy, isNull, debounce } from 'lodash';
import { PageRecipientBasicModel } from '@/helpers/entities/models/PageRecipientBasicModel';
import { PER_PAGE, DEBOUNCE } from '@/helpers/constants/app';
import PaginatorMixin from '@/helpers/mixins/PaginatorMixin';
import SearchMixin from '@/helpers/vue_mixins/v2/SearchMixin';
export default Vue.extend({
    mixins: [SearchMixin, PaginatorMixin],
    apollo: {
        pageRecipients: {
            query: PageRecipients,
            variables() {
                const vars = {
                    appUuid: this.appUuid,
                    appSegmentationUuid: this.appSegmentationUuid,
                    after: this.startCursor,
                    first: this.perPage,
                    query: this.search,
                };
                return omitBy(vars, isNull);
            },
            update(data) {
                const recipients = data.surveyRecipientsBySegment.edges;
                const recipientNode = (recipient) => {
                    return new PageRecipientBasicModel(recipient.node);
                };
                return recipients.map(recipientNode);
            },
            result({ data }) {
                const self = this;
                const query = data.surveyRecipientsBySegment;
                self.totalCount = query.totalCount;
                self.pageInfo = query.pageInfo;
            },
        },
    },
    props: {
        appUuid: {
            type: String,
            required: true,
        },
        appSegmentationUuid: {
            type: String,
            default: null,
        },
    },
    data() {
        return {
            pageRecipients: null,
            selected: null,
        };
    },
    computed: {
        firstRecipient() {
            const recipients = this.pageRecipients;
            if (recipients) {
                return recipients[0];
            }
            return null;
        },
        selectedRecipient() {
            return this.selected || this.firstRecipient;
        },
        perPage() {
            return PER_PAGE;
        },
    },
    methods: {
        select(recipient) {
            this.selected = recipient;
        },
        isSelected(recipient) {
            return this.selectedRecipient === recipient;
        },
        searchBy(keyword) {
            const self = this;
            self.pageInfo.startCursor = '';
            self.onSearch(keyword);
        },
    },
    render() {
        if (this.$scopedSlots.default) {
            const self = this;
            return this.$scopedSlots.default({
                pageRecipients: this.pageRecipients,
                selectedRecipient: this.selectedRecipient,
                select: this.select,
                isSelected: this.isSelected,
                totalCount: self.totalCount,
                pageInfo: self.pageInfo,
                fetchRecordsFrom: self.fetchRecordsFrom,
                onSearch: debounce(self.searchBy, DEBOUNCE),
            });
        }
    },
});
